import styled from "styled-components";

export const AutosuggestResultsContainer = styled.div`
  position: absolute;
  z-index: 100;
`;
